import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const LOGO_SRC = '/assets/images/logo.png';

export default function DashboardBrand() {
  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: 0.5, py: 0.5 }}>
      <Box
        component="img"
        src={LOGO_SRC}
        alt="SMAI Express"
        sx={{
          width: 44,
          height: 44,
          objectFit: 'contain',
          flexShrink: 0,
        }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          SMAI Express
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          Orders Dashboard
        </Typography>
      </Box>
    </Stack>
  );
}
